import axios from 'axios';
import { setInterceptors } from './common/interceptors';

function createInstance() {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  });
}

// request header에 인증토큰이 필요한 api는 여기 태우자!
function createInstanceWithAuth(url) {
  const instance = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}${url}`,
  });
  return setInterceptors(instance);
}

/* ===================================================================== */
/* [ login ] */
export const loginProxy = createInstance();
export const loginProxyWithAuth = createInstanceWithAuth('');

/* [ mobile-api module ] */
export const elaMobileApi = createInstanceWithAuth('ela/');
export const fileMobileApi = createInstanceWithAuth('file/');

/* [ workup module ] */
// workup-emp
export const empProxy = createInstanceWithAuth('proxy/emp/1.0/');
export const empSearchProxy = createInstanceWithAuth('proxy/emp/search/1.0/');
export const empCertiProxy = createInstanceWithAuth('proxy/emp/certi/');
export const empCertiProxyBody = createInstanceWithAuth('proxyBody/emp/certi/');
export const empCodeProxyBody = createInstanceWithAuth('proxyBody/emp/code/');

// workup-org
export const orgInfoProxy = createInstanceWithAuth('proxy/org/info/1.0/');

// workup-pay
export const payStaProxy = createInstanceWithAuth('proxy/pay/sta/');

// workup-work
export const workCodeProxy = createInstanceWithAuth('proxy/work/code/1.0/');
export const workMainProxy = createInstanceWithAuth('proxy/work/main/1.0/');
export const workAnnualProxy = createInstanceWithAuth('proxy/work/annual/');
export const workAnnualProxyBody = createInstanceWithAuth(
  'proxyBody/work/annual/',
);
export const workDailyProxy = createInstanceWithAuth('proxy/work/daily/');
export const workPsnlProxy = createInstanceWithAuth('proxy/work/psnl/');
export const workPsnlworkProxy = createInstanceWithAuth('proxy/work/psnlwork/');
export const workOrgProxy = createInstanceWithAuth('proxy/work/org/');
export const workApprovalProxy = createInstanceWithAuth('proxy/work/approval/');
export const workApprovalProxyBody = createInstanceWithAuth(
  'proxyBody/work/approval/',
);
export const workConfigProxy = createInstanceWithAuth('proxy/work/config/');
export const workMobileStatusProxy = createInstanceWithAuth(
  'proxy/work/mobile/status/',
);
export const workBizTripProxy = createInstanceWithAuth('proxy/work/bizTrip/');
export const workBizTripProxyBody = createInstanceWithAuth(
  'proxyBody/work/bizTrip/',
);

// workup-ela
export const elaViewProxy = createInstanceWithAuth('proxy/ela/view/1.0/');
export const elaAppProxy = createInstanceWithAuth('proxy/ela/app/');
export const elaAppProxyBody = createInstanceWithAuth('proxyBody/ela/app/');
export const elaApiProxy = createInstanceWithAuth('proxy/ela/api/1.0/');
export const elaApiProxyBody = createInstanceWithAuth('proxyBody/ela/api/1.0/');

// workup-config
export const configProxy = createInstanceWithAuth('proxy/ncConfig/1.0/');
export const configCodeProxy = createInstanceWithAuth('proxy/ncConfig/code/');

// workup-ncAuth
export const ncAuchProxy = createInstanceWithAuth('proxy/ncAuth/1.0/');

// board
export const boardProxy = createInstanceWithAuth('proxy/board/2.0/');

// worklog
export const workLogProxy = createInstanceWithAuth('proxy/emp/workLog/1.0/');
export const workLogProxyBody = createInstanceWithAuth(
  'proxyBody/emp/workLog/1.0/',
);
